import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodOptionalDate, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminTradesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
    tab: z.enum(['over', 'ongoing', 'upcoming', 'all']).default('all'),
    labTradeId: z.number().optional(),
    date: zodOptionalDate,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/admin/Trades/AdminTradesPage/AdminTradesPage').then((d) => d.Route));
